document.addEventListener('DOMContentLoaded', ()=>{
    const accordionWrapper = document.querySelector('[data-accordions]');

    if ( accordionWrapper ) {
        const accordions = document.querySelectorAll('.accordion-panel');

        const accButtons = document.querySelectorAll('[data-accordion-trigger]')
        const accItems = document.querySelectorAll('[data-accordion-item-content]');


        const scrollToAccordion = (element) => {
            setTimeout(() => {
                const headerOffset = 100;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }, 300); // Same timeOut as transition for accordion transition animation
        };

        accButtons.forEach((trigger, index)=>{
            trigger.addEventListener('click', ()=>{
                if (trigger.getAttribute('aria-expanded') ==='true'){
                    trigger.setAttribute('aria-expanded', 'false')
                    accItems[index].dataset.show = 'false'
                }else{
                    accItems[index].dataset.show = 'true'
                    trigger.setAttribute('aria-expanded', 'true');

                    accButtons.forEach((triggerJ, index)=>{
                        if (trigger !== triggerJ){
                            accItems[index].dataset.show = 'false'
                            triggerJ.setAttribute('aria-expanded', 'false');
                        }
                    })


                    scrollToAccordion(trigger);
                }
            })
        })
    }
})
